module.exports = __webpack_public_path__ + "static/media/arrows-alt-h.7cbea0be.svg";